import { h, Component } from "preact";
import { css } from "emotion";
import Modal from "../../components/Modal";
import config from "../../config";
import ShareIcon from "../../assets/images/ShareIcon";
import FacebookIcon from "../../assets/icons/Facebook";
import LinkedInIcon from "../../assets/icons/LinkedIn";
import TwitterIcon from "../../assets/icons/Twitter";
import { hexToRgba } from "../../utils/Format";

const styles = {
  icon: css`
    margin-right: 12px;
    width: 30px;
    height: 30px;
    display: inline-block;
  `
};
/**
 * Display social media sharing links
 * This can be either div box or modal
 *
 * @class SocialMedia
 * @extends {Component}
 */
class SocialMedia extends Component {
  constructor(props) {
    super(props);
    this.state = { modalVisibility: false };
  }

  openModal = () => {
    this.setState({ modalVisibility: !this.state.modalVisibility });
  };

  render() {
    const {
      modal = false,
      slug,
      listViewType,
      showPrice,
      eventCardBackgroundColor,
      cardAndBarOpacity
    } = this.props;
    const { modalVisibility } = this.state;
    const tourLink = encodeURI(`${config("TICKETING_URL")}/tours/${slug}`);
    let wrapperHeight = "132px";
    if (listViewType === "date") {
      wrapperHeight = showPrice ? "120px" : "100px";
    }
    const customStyles = {
      wrapper: css`
        width: 100%;
        max-width: 264px;
        height: ${wrapperHeight};
        padding: 16px;
        background-color: ${hexToRgba(
          eventCardBackgroundColor,
          cardAndBarOpacity
        )};
        border-radius: 4px;
        box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);
        @media (max-width: 900px) {
          display: none;
        }
      `,
      title: css`
        font-size: 16px;
        margin-bottom: 16px;
        font-weight: 600;
        color: ${eventCardBackgroundColor === "#ffffff"
          ? "#323232"
          : "#ffffff"};
      `
    };
    const iconColor =
      eventCardBackgroundColor === "#ffffff" || modalVisibility
        ? "#788391"
        : "#ffffff";

    const contents = (
      <div>
        <a
          href={`https://www.facebook.com/sharer.php?u=${tourLink}`}
          target="_blank"
        >
          <div className={styles.icon} id="tour-social-media-facebook">
            <FacebookIcon color={iconColor} />
          </div>
        </a>
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${tourLink}`}
          target="_blank"
        >
          <div className={styles.icon}>
            <LinkedInIcon color={iconColor} />
          </div>
        </a>
        <a
          href={`https://twitter.com/intent/tweet?url=${tourLink}&hashtags=humanitix&original_referer=https%3A%2F%2Fwww.humanitix.com%2Fau%2Fsearch`}
          target="_blank"
        >
          <div className={styles.icon}>
            <TwitterIcon color={iconColor} />
          </div>
        </a>
      </div>
    );
    if (modal) {
      return (
        <div>
          <button onClick={this.openModal} style={{ padding: 0 }}>
            <ShareIcon color={iconColor} />
          </button>
          <Modal
            showModal={modalVisibility}
            closeHandler={this.openModal}
            title="Social Media"
            maxWidth={100}
            contents={<div>{contents}</div>}
          />
        </div>
      );
    }
    return (
      <div className={customStyles.wrapper}>
        <div className={customStyles.title}>Share</div>
        {contents}
      </div>
    );
  }
}

export default SocialMedia;



// WEBPACK FOOTER //
// ./routes/tours/SocialMedia.js